<template>
  <mdb-card class="mt-3 grey lighten-5">
    <mdb-card-body>
      <mdb-card-text>
        <div class="title">1. 지도 목표</div>
        <div class="ml-4 my-2" v-html="$linebreak(plan.objective)"/>
        <div class="title mt-2">2. 훈련교재</div>
        <div class="ml-4 my-2" v-html="$linebreak(plan.book)"/>
        <div class="title mt-2">3.주요 교수계획</div>
        <ol>
          <li v-for="(l,i) in lectures" :key="i">
             <span class="bolder">{{l.name}} / {{l.code}} ({{l.hours}}시간)</span>
             <ol>
               <li v-for="(u,i) in l.units" :key="i">
                 {{u.name}} / {{u.code}} ({{u.hours}}시간)</li>
             </ol>
          </li>
        </ol>
        <div class="title mt-2">4. 교수학습방법</div>
        <div  class="ml-4 my-2">
          <mdb-icon v-if="plan.lectureMethods[0]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 이론강의</span>
          <mdb-icon v-if="plan.lectureMethods[1]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 개인별실습</span>
          <mdb-icon v-if="plan.lectureMethods[2]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 조별실습</span>
          <span v-if="plan.lectureMethods[3]">
            <mdb-icon  icon="check-square" /> 기타 ({{plan.lectureMethods[3]}})
          </span>
          <span v-else><mdb-icon far icon="square"/> 기타</span>
        </div>
        <div class="title mt-2">5. 평가방법</div>
        <div  class="ml-4 my-2">
          <mdb-icon v-if="plan.evalMethods[0]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 필답형평가</span>
          <mdb-icon v-if="plan.evalMethods[1]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 포트폴리오</span>
          <mdb-icon v-if="plan.evalMethods[2]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 사례발표</span>
          <mdb-icon v-if="plan.evalMethods[3]" icon="check-square" />
          <mdb-icon v-else far icon="square"/>
          <span class="mr-4"> 수행평가</span>
          <span v-if="plan.evalMethods[4]">
            <mdb-icon  icon="check-square" /> 기타 ({{plan.evalMethods[4]}})
          </span>
          <span v-else><mdb-icon far icon="square"/> 기타</span>
        </div>
        <div class="title mt-2">6. 훈련시설</div>
        <mdb-tbl sm class="ml-4">
          <mdb-tbl-head>
            <tr><th>시설명</th><th>면적</th></tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(f, i) in plan.facilities" :key="i">
              <td>{{f.name}}</td><td>{{f.area}}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <div class="title mt-2">7. 활용 훈련장비</div>
        <mdb-tbl sm class="ml-4">
          <mdb-tbl-head>
            <tr><th>장비명</th><th>모델명</th><th>단위</th><th>수량</th></tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(d, i) in plan.devices" :key="i">
              <td>{{d.name}}</td>
              <td>{{d.model}}</td>
              <td>{{d.unit}}</td>
              <td>{{d.amount}}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'Plan',
  components: { mdbCard, mdbCardBody, mdbCardText, mdbTbl, mdbTblHead, mdbTblBody },
  props: ['plan', 'lectures']
}
</script>
